<script>
    import { createEventDispatcher } from "svelte";
    import {
        Switch,
        SwitchLabel,
        SwitchGroup,
    } from "@rgossiaux/svelte-headlessui";
    import Help from "./ui/Help.svelte";
    
    export let label;
    export let screenreaderText;
    export let checked;
    
    const dispatch = createEventDispatcher();
</script>

{#if label}
    <SwitchGroup>
        <div class="switch-container">
            <Switch checked={checked} on:change={(e) => {checked = e.detail; dispatch("change", {checked})}} class={checked ? "switch switch-enabled" : "switch switch-disabled"}>
                <span class="sr-only">{screenreaderText}</span>
                <span class="toggle" class:toggle-on={checked} class:toggle-off={!checked} />
            </Switch>
            <SwitchLabel class="switch-label">{label}</SwitchLabel>
        </div>
    </SwitchGroup>
{:else}
    <Switch checked={checked} on:change={(e) => {checked = e.detail; dispatch("change", {checked})}} class={checked ? "switch switch-enabled" : "switch switch-disabled"}>
        <span class="sr-only">{screenreaderText}</span>
        <span class="toggle" class:toggle-on={checked} class:toggle-off={!checked} />
    </Switch>
{/if}



<style>
    .switch-container {
        display: flex;
        align-items: center;
        margin: 1rem 0;
    }

    :global(.switch-label) {
        padding-left: 1rem;
        user-select: none;
    }

    :global(.switch) {
        position: relative;
        display: inline-flex;
        align-items: center;
        border-radius: 0.75rem;
        height: 1.5rem;
        width: 2.75rem;
        padding: 0.5rem;
        transition-property: color, background-color, border-color,
        text-decoration-color, fill, stroke;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        transition-duration: 150ms;
    }

    :global(.switch:focus-visible) {
        /* outline: 2px solid transparent;
        outline-offset: 2px; */
        box-shadow: 0 0 0 2px black;
    }

    :global(.switch-enabled) {
        /* Blue */
        background-color: #87C777;
    }

    :global(.switch-disabled) {
        /* Gray */
        background-color: #ebe6e2;
    }

    .sr-only {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border-width: 0;
    }

    .toggle {
        display: inline-block;
        width: 1rem;
        height: 1rem;
        background-color: rgb(255 255 255);
        border-radius: 50%;
        transition: transform 200ms ease-in-out;
    }

    .toggle-on {
        transform: translateX(1.1rem);
    }

    .toggle-off {
        transform: translateX(-0.25rem);
    }
</style>